/**
 * The type of media
 */
export enum MediaType {
  /**
   * A video message sent after a missed call.
   */
  VideoMessage = 'video-message',

  /**
   * Stores Entity Service image to place on the app button.
   */
  EntityServiceImage = 'entity-service-image',

  /** ------------------- */

  /**
   * A photograph, a picture produced using a camera.
   */
  Photo = 'photo',

  /**
   * The act of making a picture with a pencil or pen.
   */
  Drawing = 'drawing',

  /**
   * A recording of moving photos and sound.
   */
  Video = 'video',

  /**
   * The recording and broadcasting of sound.
   */
  Audio = 'audio',

  /**
   * The act of painting.
   */
  Painting = 'painting',
}
